import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../Widget'
import { QA_NAME_LISTING_PROFILE_WIDGET_PERFORMANCE } from '../RentalPortalListingProfile.constants'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { ListingProfileWidgetPerformanceItem } from './ListingProfileWidgetPerformanceItem'
import { ListingProfileWidgetPerformanceSkeleton } from './ListingProfileWidgetPerformanceSkeleton'
import {
  getIsListingPerformanceWidgetShown,
  getListingPerformanceMetrics,
} from './RentalPortalListingProfileWidgetPerformance.utils'

import * as styles from './RentalPortalListingProfileWidgetPerformance.module.css'

function RentalPortalListingProfileWidgetPerformance() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  return getIsListingPerformanceWidgetShown({ isInitiated, listingData }) ? (
    <Widget
      contentContainerProps={{
        Skeleton: ListingProfileWidgetPerformanceSkeleton,
        className: styles.content,
      }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      qaName={QA_NAME_LISTING_PROFILE_WIDGET_PERFORMANCE}
      title={t('RentalPortal.ListingProfilePerformanceWidgetTitleKey')}
    >
      <div className={styles.grid}>
        {getListingPerformanceMetrics(listingData?.performance).map(
          ({ key, labelKey, value }) => (
            <ListingProfileWidgetPerformanceItem
              key={key}
              label={t(labelKey)}
              metricKey={key}
              value={value}
            />
          )
        )}
      </div>
    </Widget>
  ) : null
}

export default RentalPortalListingProfileWidgetPerformance
